import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ContractHoldersContent from "./ContractHoldersContent";

import { getContractHoldersGroups } from "../../../api/contractHolders";
import { getContractHolderData } from "../../../api/fedRamp";
import { GENERIC_ERROR_STRING } from "../../../constants";

/**
 * FedRamp Contract Holders Modal
 * @param {Object} props
 * @param {number} props.productSeq
 * @param {number} props.providerSeq
 * @param {string} props.product
 * @param {function} props.closeModal
 * @returns {Element}
 * @constructor
 */
export default function ContractHolders({ productSeq, providerSeq, product, closeModal }) {
  const [contractHoldersGroups, setContractHoldersGroups] = useState(/** @type ContractHolderGroup[]*/[]);
  const [contractHolderData, setContractHolderData] = useState(/** @type FedRampContractHolder[]*/[]);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const [contractHoldersGroupsResponse, contractHolderDataResponse] = await Promise.all(
          [getContractHoldersGroups(true), getContractHolderData(productSeq, providerSeq)]);

        setContractHoldersGroups(contractHoldersGroupsResponse);
        setContractHolderData(contractHolderDataResponse.data);

      } catch (error) {
        setError(error);
      }
    })();
  }, []);

  let modalContent;

  if (error) {
    modalContent = <p>{GENERIC_ERROR_STRING}</p>;
  } else if (contractHoldersGroups.length > 0 && contractHolderData.length > 0) {
    modalContent = <ContractHoldersContent product={product} contractHoldersGroups={contractHoldersGroups}
                                           contractHolderData={contractHolderData}/>;
  } else {
    modalContent = <p>Loading Contract Holders</p>;
  }

  return (<Dialog open={true} onClose={closeModal} maxWidth="lg">
    <DialogTitle sx={{ m: 0, p: 2, color: "white", backgroundColor: "#2D5986", padding: "8px 16px" }}>
      Contract Holders
    </DialogTitle>
    <IconButton
      aria-label="close"
      onClick={closeModal}
      sx={{
        position: "absolute", right: 0, top: 0, color: "white",
      }}
    >
      <CloseIcon/>
    </IconButton>
    <DialogContent>
      {modalContent}
    </DialogContent>
  </Dialog>);
}

ContractHolders.propTypes = {
  productSeq: PropTypes.number.isRequired,
  providerSeq: PropTypes.number.isRequired,
  product: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
};